export enum UserQuickFilter {
  All,
  Active,
  RequiresAction,
  Inactive
}
